import React from 'react';

class ErrorHandler extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: true,
    };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    // this.props.store.dispatch({ type: PURGE, key: 'root', result: () => null });
  }

  render() {
    return this.props.children;
  }
}

export { ErrorHandler };



// WEBPACK FOOTER //
// ./src/app/components/ErrorHandler/index.js